import MenuComponent from "./MenuComponent";

export default MenuComponent;
